export default {
  URL: __URL__,
  API_URL: __API_URL__,
  WS_URL: __WS_URL__,
  OKTA_URL: __OKTA_URL__,
  OKTA_REDIRECT: __OKTA_REDIRECT__,
  TIMEOUT1: __TIMEOUT1__,
  TIMEOUT2: __TIMEOUT2__,
  ENABLE_CUSTOM_LOGIN: __ENABLE_CUSTOM_LOGIN__,
  TELEMED_LINK: __TELEMED_LINK__,
  BEFORE_REFRESH: __BEFORE_REFRESH__,
  OKTA_DEFAULT: __OKTA_DEFAULT__,
  CLEAR_TRIAGE_KEY: __CLEAR_TRIAGE_KEY__,
  DATADOG_ID: __DATADOG_ID__,
  DATADOG_TOKEN: __DATADOG_TOKEN__,
  GOOGLE_MAPS_TOKEN: __GOOGLE_MAPS_TOKEN__,
  S3_BUCKET_NAME: __S3_BUCKET_NAME__,
  ENCRYPT_STORAGE_TOKEN: __ENCRYPT_STORAGE_TOKEN__,
  AI_BASE_URL: __AI_BASE_URL__,
  LAUNCH_DARKLY_CLIENT_ID: __LAUNCH_DARKLY_CLIENT_ID__,
  NIC_CLIENT_ID: __NIC_CLIENT_ID__,
  NIC_REDIRECT: __NIC_REDIRECT__,
  RTG_HOST: __RTG_HOST__,
  RTG_PROTOCOL: __RTG_PROTOCOL__
}
